<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-md-8  col-lg-6">
        <div class="page-header">
          <h1>Forgot Password</h1>
        </div>
      </div>
    </div>

    <div id="content">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col col-md-8  col-lg-6">
            <ShowErrors
              :errorMessages="errorMessages"
            />
            <p>
              Please enter the email address you registered with website below and
              we'll email you a link to a page where you can easily create a new password.
            </p>
            <form>
              <div class="form-group">
                <label for="email">Your Email</label>
                <input type="email" name="email" class="form-control form-control-lg"
                      v-model="user.email" v-validate="'required|email'">
                <span v-show="errors.has('email')" class="input-error">
                  Please enter a valid email address.
                </span>
              </div>

              <button type="button" class="btn btn-primary btn-lg" v-on:click="validate()">
                Send Email
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowErrors from '../common/ShowErrors'

export default {
  name: 'ForgotPassword',
  components: {
    ShowErrors
  },
  data: function () {
    return {
      user: {
        email: null
      },
      errorMessages: []
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.forgotPassword()
        }
      })
    },
    forgotPassword () {
      this.errorMessages = []
      var self = this

      this.$http.post('passwords/forgot', { email: this.user.email }).then(function (response) {
        self.$router.push('/reset-password')
      }).catch(function (error) {
        if (error) {
          var errorMsg = error.response.data.message || error.response.data.error
          self.errorMessages.push(errorMsg)
        }
      })
    }
  }
}
</script>
